define('modules/filter/filter_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  './filter_model',

  'modules/form/form_view',
  'modules/form/convert-form-data',

  'modules/loading/loading_spinner_view',

  'text!./filter_template.html'
], function (Backbone, $, _,
             session,
             FilterModel,
             FormView,
             convertFormData,
             Loading,
             filter_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (options) {

      _.extend(this, options);
      this.subViews = [];

      var filterParams = {
        id: this.filter_id, 
        moduleApi: (this.moduleApi ? this.moduleApi : null),
        hasStaticZone: this.hasStaticZone
      };

      this.model = new FilterModel(filterParams);
      this.filterModel = new FilterModel(filterParams);

      this.render();

      var loading = new Loading();
      this.subViews.push(loading);

      this.listenTo(this.filterModel, 'request', loading.start.bind(loading));

      this.listenTo(this.model, 'request', loading.start.bind(loading));

      this.listenTo(this.model, 'change', function (model) {
        this.renderFilter();
        Backbone.trigger('render:form');
      }, this);

      this.listenTo(this.filterModel, 'sync', function (model) {
        loading.done();
        this.model.set(model.toJSON());

        if (this.dataModel) {
          this.dataModel.set('filter_id', model.get('id'), {silent: true});
          this.dataModel.set('moduleApi', model.get('moduleApi'), {silent: true});
          this.dataModel.trigger('change', {changed: 'filter'});
        }

      }, this);

      this.listenTo(this.model, 'sync', function (model) {
        loading.done();
        this.updateDataModel();
      }, this);

    },

    subViews: [],
    tagName: 'div',
    className: 'js-filter-form filter-form',

    template: _.template(filter_template),

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    isLoading: false,

    renderFilter: function () {

      this.filterForm = new FormView({
        filter_id: this.model.get('id'),
        fields: this.model.get('filters'),
        readonly: this.readonly
      });
      
      this.listenTo(this.filterForm.dataModel, 'change', function (e) {
      
        this.$('.tags').each(function () {
          if (this.selectize) {
            this.selectize.lock();
          }
        });

        this.updateDataModel();
        this.syncFilter();

      }, this);

      this.$('#filter').html(this.filterForm.$el);

      if (this.model.get('infotext') && this.model.get('infotext').toptext.trim()) {
        this.$('.js-filter-infotext--toptext').html('<div class="filter-toptext">' + this.model.get('infotext').toptext + '</div>');
      }
      Backbone.trigger('render:filter');
      return this;

    },

    updateDataModel: function () {
      var filter_id = this.model.get('id');
      var moduleApi = this.model.get('moduleApi');

      this.filterModel.clear({silent: true});
      this.filterModel.set('id', filter_id).set('moduleApi', moduleApi).set(this.filterForm.dataModel.toJSON());

    },

    syncFilter: function () {
      this.filterModel.save();
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }

  });
  return View;
});

